import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/UserContext';
import toast from 'react-hot-toast';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requirePremium?: boolean;
  requireAdmin?: boolean;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requirePremium = false,
  requireAdmin = false,
  redirectTo = '/login',
}) => {
  const { isAuthenticated, isLoading, isPremium, user } = useAuth();
  const location = useLocation();

  // 显示加载状态
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-tennis-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">加载中...</p>
        </div>
      </div>
    );
  }

  // 检查是否已认证
  if (!isAuthenticated) {
    // 保存当前路径，登录后可以跳转回来
    const from = location.pathname + location.search;
    toast.error('请先登录以访问此页面');
    return <Navigate to={redirectTo} state={{ from }} replace />;
  }

  // 检查是否需要管理员权限
  if (requireAdmin) {
    const isAdmin = user?.role === 'admin' || user?.role === 'administrator';
    if (!isAdmin) {
      toast.error('此功能需要管理员权限');
      return <Navigate to="/" replace />;
    }
  }

  // 检查是否需要会员身份
  if (requirePremium && !isPremium) {
    toast.error('此功能需要会员身份，请升级为会员');
    return <Navigate to="/membership" replace />;
  }

  // 用户已认证且满足所有要求
  return <>{children}</>;
};

export default ProtectedRoute;